import React from "react";
import './FiberInternet.css';

const TelekomInternet = () => {
    return (
        <section className="telekom-container" aria-labelledby="fiber-benefits">
            <header className="telekom-header">
                <h2 id="fiber-benefits" className="telekom-title">
                    Neden Fiber Ev İnterneti Tercih Etmelisiniz?
                </h2>

                <p className="telekom-subtitle">
                    Fiber internet, yüksek hız ve düşük gecikme ile en iyi internet deneyimini sunar.
                </p>
            </header>

            <div className="features-grid">
                <div className="feature-card">
                    <img
                        src="https://cdn.prod.website-files.com/6851aa1c6adbbffe6510349d/6853126da3e00c3db128db9c_feature-01b.png"
                        loading="lazy"
                        alt="Kesintisiz Bağlantı"
                        className="feature-icon"
                    />
                    <h3 className="feature-title">Kesintisiz Bağlantı</h3>
                    <p className="feature-description">
                        Hızlı ve stabil internetle kesintisiz bir deneyim yaşayın. Telekom internet, her an her yerde güçlü bağlantı sağlar.
                    </p>
                </div>

                <div className="feature-card">
                    <img
                        src="https://cdn.prod.website-files.com/6851aa1c6adbbffe6510349d/6853126d76df03408017809e_game.png"
                        loading="lazy"
                        alt="Oyun Deneyimi"
                        className="feature-icon"
                    />
                    <h3 className="feature-title">Oyun Deneyimi</h3>
                    <p className="feature-description">
                        Kesintisiz oyun keyfiyle en iyi performansı yaşayın. Hızlı bağlantıyla oyun dünyasının tadını çıkarın.
                    </p>
                </div>

                <div className="feature-card">
                    <img
                        src="https://cdn.prod.website-files.com/6851aa1c6adbbffe6510349d/6853126d958d31b8be6e7cc0_movie.png"
                        loading="lazy"
                        alt="Film Keyfi"
                        className="feature-icon"
                    />
                    <h3 className="feature-title">Film Keyfi</h3>
                    <p className="feature-description">
                        HD film ve dizi izleme deneyimiyle eğlencenin tadına varın. İstediğiniz an yüksek kalitede görüntü keyfi.
                    </p>
                </div>

                <div className="feature-card">
                    <img
                        src="https://cdn.prod.website-files.com/6851aa1c6adbbffe6510349d/6853126dff05621cd134fb1d_music.png"
                        loading="lazy"
                        alt="Müzik Keyfi"
                        className="feature-icon"
                    />
                    <h3 className="feature-title">Müzik Keyfi</h3>
                    <p className="feature-description">
                        Sınırsız müzik akışı ile ruhunuza hitap eden melodileri keşfedin. Müzik dinleme keyfini doyasıya yaşayın.
                    </p>
                </div>
            </div>

            <div className="coverage-section">
                <h2 className="coverage-title">Tüm Türkiye'de Güvenli ve Hızlı Bağlantı</h2>
                <p className="coverage-description">
                    Ev interneti fiyatları ve güncel kampanyalar hakkında bilgi almak için bize ulaşın. Sunduğumuz hizmetler ve yeni abonelik fırsatlarıyla size en iyi çözümleri sunmaya hazırız!
                </p>
            </div>
        </section>
    );
};

export default TelekomInternet;